import { DiscountConfig, ExchangeFormData, MarkupConfig } from '../../../../types/sales.types';

export const createInitialExchangeDiscountConfig = (): DiscountConfig => ({
  enabled: false,
  scope: 'PER_ITEM',
  allowIndividualDiscounts: false,
  orderDiscountType: 'AMOUNT',
  orderDiscountValue: 0,
});

export const createInitialExchangeMarkupConfig = (): MarkupConfig => ({
  enabled: false,
  scope: 'PER_ITEM',
  allowIndividualMarkups: false,
  orderMarkupType: 'AMOUNT',
  orderMarkupValue: 0,
});

export const createInitialExchangeFormData = (orderId: number): ExchangeFormData => ({
  originalOrderId: orderId,
  itemsToExchange: [],
  newProducts: [],
  exchangeReason: '',
  exchangeNotes: '',
  payments: [],
  markupConfig: createInitialExchangeMarkupConfig(),
  discountConfig: createInitialExchangeDiscountConfig(),
  paymentConfig: {
    allowPartialPayment: false,
    allowMultiplePayments: false,
  },
});
